<template>
    <q-page padding>
        <q-tabs v-model="tab" color="white" text-color="primary" underline-color="primary" class="shadow-1 bg-white" align="justify">
            <q-tab slot="title" name="presential" :label="$t('presential')" icon="fal fa-graduation-cap" />

            <q-tab-pane name="presential" class="q-px-md q-pb-xl q-mt-md">
                <div>
                    <div class="row gutter-sm" v-if="$q.platform.is.desktop">
                        <div class="col-sm-11">
                            <p class="q-title">{{ title }}</p>
                            <p class="q-body-1 text-weight-light">{{ description }}</p>
                            <p class="q-body-1 text-weight-light">{{ `${$t('timezone')}: ${getHumanTimezone(timezone)}` }}</p>
                            <p class="q-my-xs text-weight-bold">{{ $t('instructors') }}</p>
                            <div class="q-my-sm" v-for="(instructor, index) in instructors_list" :key="index">
                                <p class="q-my-xs">{{ instructor }}</p>
                            </div>
                            <q-btn :color="getSubscribeButtonColor" :label="$t(getSubscribeButtonLabel)" :icon="getSubscribeButtonIcon" @click="showSubscription()" />
                        </div>

                        <div class="col-sm-1 cursor-pointer" @click="showCertificate()">
                            <vc-donut :sections="!course.is_open ? sections : []" :size="100" unit="%">
                                <h6 v-if="user_progress <= 99 && presential_event_user_result_status != 1 && presential_event_user_result_status != 2 && !course.is_open" class="text-primary">
                                    {{ getPercentage(user_progress) }}%
                                </h6>

                                <q-icon :name="getResult" :color="getResultColor" size="2rem" v-if="user_progress >= 100 || presential_event_user_result_status == 1 || presential_event_user_result_status == 2 && !course.is_open" />

                                <q-icon name="fal fa-clock" color="primary" size="2rem" v-if="course.is_open">
                                    <q-tooltip>
                                        {{ $t('this_course_is_being_published_your_progress_will_show_when_its_finished') }}
                                    </q-tooltip>
                                </q-icon>

                                <q-tooltip v-if="presential_event_user_result_status == 2">
                                    {{ `${$t('you_were_reproved_in')} ${presential_event_user_result_date}` }}
                                </q-tooltip>
                            </vc-donut>
                        </div>
                    </div>

                    <div class="row gutter-xs" v-if="$q.platform.is.mobile">
                        <div class="col-xs-10">
                            <p class="q-title">{{ title }}</p>
                            <div class="col-xs-12 col-sm-11">
                                <p class="q-body-1 text-weight-light">{{ description }}</p>
                                <p class="q-my-xs text-weight-bold">{{ $t('instructors') }}</p>
                                <div class="q-my-sm" v-for="(instructor, index) in instructors_list" :key="index">
                                    <p class="q-my-xs">{{ instructor }}</p>
                                </div>
                            </div>
                            <q-btn class="order-last" :color="getSubscribeButtonColor" :label="$t(getSubscribeButtonLabel)" :icon="getSubscribeButtonIcon" @click="showSubscription()" />
                        </div>

                        <div class="col-xs-2" @click="showCertificate()">
                            <vc-donut :sections="!course.is_open ? sections : []" :size="100" unit="%">

                                <h6 v-if="user_progress <= 99 && presential_event_user_result_status != 1 && presential_event_user_result_status != 2 && !course.is_open" class="text-primary">
                                    {{ getPercentage(user_progress) }}%
                                </h6>

                                <q-icon :name="getResult" :color="getResultColor" size="1.7rem" v-if="user_progress >= 100 || presential_event_user_result_status == 1 || presential_event_user_result_status == 2 && !course.is_open" />

                                <q-tooltip v-if="presential_event_user_result_status == 2">
                                    {{ `${$t('you_were_reproved_in')} ${presential_event_user_result_date}` }}
                                </q-tooltip>
                            </vc-donut>
                        </div>

                    </div>

                    <div class="row reverse gutter-sm q-mt-sm">
                        <div :class="$q.platform.is.ipad ? 'col-4' : 'col-xs-12 col-sm-2'" v-if="$route.name == 'view_presential'">
                            <q-btn :label="$t('back')" color="primary" icon="far fa-chevron-left" class="full-width" @click="$router.push({ name: 'presential' })" />
                        </div>

                        <div class="col-xs-12 col-sm-2" v-if="$route.name == 'trail_course'">
                            <q-btn :label="$t('back')" color="primary" icon="far fa-chevron-left" class="full-width" @click="$router.push({ name: 'trail', params: { id: $route.params.id_trail } })" />
                        </div>
                    </div>

                    <q-tabs v-model="tab_course" color="secondary" underline-color="primary" align="justify" class="q-mt-md">
                        <q-tab slot="title" name="activities" :label="$q.platform.is.desktop ? `${$t('activities')} (${qty_presential_activities})` : `(${qty_presential_activities})`" icon="fal fa-pen" />
                        <q-tab  slot="title" v-if="user_subscribed" name="support_materials" :label="$q.platform.is.desktop ? `${$t('support_materials')} (${qty_presential_materials})` : `(${qty_presential_materials})`" icon="fal fa-books" />
                        <q-tab slot="title" v-if="user_subscribed" name="reaction_test" :label="$q.platform.is.desktop ? `${$t('reaction_test')} (${qty_presential_evaluations})` : `(${qty_presential_evaluations})`" icon="fal fa-clipboard-list-check" />

                        <q-tab-pane name="activities" style="padding: 5px 1px;">
                            <activities @reloadActivity="reloadActivity" :address="address" :course="course" :user_subscribed="user_subscribed" />
                        </q-tab-pane>

                        <q-tab-pane  name="support_materials" class="q-px-md q-pb-xl q-mt-md">
                            <support-materials />
                        </q-tab-pane>

                        <q-tab-pane name="reaction_test" class="q-px-md q-pb-xl q-mt-md">
                            <reaction-test @reloadActivity="reloadActivity" />
                        </q-tab-pane>
                    </q-tabs>
                </div>
            </q-tab-pane>
        </q-tabs>

        <q-dialog prevent-close v-model="confirm_subscribe_presential">
            <span slot="title">{{ user_subscribed ? $t('unsubscribe') : $t('subscribe') }}</span>

            <span slot="message">
                {{
                    user_subscribed
                    ? $t('unsubscribe_confirmation')
                    : $t('subscribe_confirmation')
                 }}
            </span>

            <span slot="body" v-if="!user_subscribed">
                <q-field>
                    <q-checkbox v-model="check_emails_presential" :label="$t('receive_emails_about_this_training')" />
                </q-field>
            </span>

            <template slot="buttons" slot-scope="props">
                <q-btn color="tertiary" :label="$t('close')" @click="hideCourseInfo()"/>
                <q-btn
                    :color="user_subscribed ? 'negative' : 'positive'"
                    :label="user_subscribed ? $t('unsubscribe') : $t('subscribe')" @click="toggleSubscription" />
            </template>
        </q-dialog>

        <certificate :show="show_certificate" :data="certificate_data" :certificate="certificate" @hideCertificate="hideCertificate" />
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import Activities from 'components/presential_viewer/Activities'
import ReactionTest from 'components/presential_viewer/ReactionTest'
import SupportMaterials from 'components/presential_viewer/SupportMaterials'
import Certificate from 'components/Certificate'
import { date } from 'quasar'
const { formatDate } = date
import { required, email, requiredIf } from 'vuelidate/lib/validators'
import * as moment from 'moment'
import * as tz from 'moment-timezone'

export default {
    i18nOptions: { namespaces: [ 'custom', 'common', 'presential', 'courses', 'training'] },

    data() {
        return {
            tab: 'presential',
            tab_course: 'activities',
            title: '',
            description: '',
            timezone: '',
            instructors_list: [],
            address: '',
            qty_presential_activities: 0,
            qty_presential_evaluations: 0,
            qty_presential_materials: 0,
            user_progress: 0,
            presential_event_user_result_status: null,
            presential_event_user_result_percent: null,
            presential_event_user_result_date: '',
            sections: [],
            show_certificate: false,
            certificate_data: [],
            course: [],
            certificate: {},
            id_course : '',
            owners: null,
            name: '',
            email: '',
            message: '',
            block_fields: false,
            user_subscribed: '',
            confirm_subscribe_presential: false,
            check_emails_presential: true,
            qty_vacancies: 0
        }
    },

    components: {
        'activities': Activities,
        'reaction-test': ReactionTest,
        'support-materials': SupportMaterials,
        'certificate': Certificate
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            name_store: 'common/full_name',
            email_store: 'common/email',
            clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getResult() {
            if (this.presential_event_user_result_status == 1) {
                return 'fal fa-trophy'
            }
            else if (this.presential_event_user_result_status == 2) {
                return 'fal fa-ban'
            }
            else if (!this.presential_event_user_result_status) {
                if (this.course.status === 3) return 'fal fa-play'
                if (this.course.status === 4) return 'fal fa-pause'
                if (this.course.status === 5) return 'fal fa-clipboard-list-check'
            }
        },

        getResultColor() {
            if (this.presential_event_user_result_status == 1) {
                return 'positive'
            }
            else if (this.presential_event_user_result_status == 2) {
                return 'negative'
            }
            else if (!this.presential_event_user_result_status) {
                return 'info'
            }
        },

        showSubscribeButton() {
            if (this.presential_event_type === 1) {
                if (this.status === 8) return false
            }
            else return false
        },

        getSubscribeButtonLabel() {
            if (!this.user_subscribed && this.qty_vacancies <= 0) return 'no_vacancy'
            else if (!this.user_subscribed) return 'subscribe'
            else return 'unsubscribe'
        },

        getSubscribeButtonIcon() {
            if (!this.user_subscribed && this.qty_vacancies <= 0) return 'fal fa-users-slash'
            else if (!this.user_subscribed) return 'far fa-sign-in'
            else return 'far fa-sign-out'
        },

        getSubscribeButtonColor() {
            if (!this.user_subscribed && this.qty_vacancies <= 0) return 'negative'
            else if (!this.user_subscribed) return 'primary'
            else return 'tertiary'
        },
    },

    methods: {
        fetchCourse() {
            this.$q.loading.show()
            this.$axios.get(`/etraining_presential/presential/${this.id_course}/`, this.getHeader)

            .then(response => {
                this.course = response.data

                this.title = response.data.title
                this.description = response.data.description
                this.instructors_list = response.data.instructors_list ? response.data.instructors_list.map(e => e.name) : []
                this.address = response.data.address
                this.qty_presential_activities = response.data.qty_presential_activities
                this.qty_presential_evaluations = response.data.qty_presential_evaluations
                this.qty_presential_materials = response.data.qty_presential_materials
                this.user_progress = parseInt(response.data.user_progress)
                this.presential_event_user_result_status = response.data.presential_event_user_result_status
                this.presential_event_user_result_score = response.data.presential_event_user_result_score
                this.presential_event_user_result_date = date.formatDate(response.data.presential_event_user_result_date, 'DD/MM/YYYY')
                this.user_subscribed = response.data.user_subscribed
                this.owners = response.data.owners
                this.timezone = response.data.timezone
                this.qty_vacancies = response.data.qty_vacancies

                if (this.owners && this.owners.length < 1) {
                    this.owners = null
                }

                this.sections = []

                this.sections.push({
                    value: this.user_progress ? this.user_progress > 100 ? 100 : this.user_progress : 0,
                    color: this.getDonutColor(this.user_progress)
                })

                this.$q.loading.hide()
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)

                if (e.response.status === 404) {
                    this.$q.notify({
                        message: this.$t('not_allowed_or_page_not_found'),
                        type: 'negative',
                        icon: 'fal fa-ban'
                    })
                    if (process.env.PROJECT_FOLDER !== 'academiacoral') {
                        this.$router.push({ name: 'presential' })
                    }
                }
            })
        },

        showSubscription() {
            if (!this.user_subscribed && this.qty_vacancies <= 0) return
            else this.confirm_subscribe_presential = true
        },

        toggleSubscription() {
            this.$q.loading.show()

            let data = {
                    'receive_notifications': this.check_emails_presential,
                    'subscribe': this.user_subscribed ? false : true
                }

            this.$axios.post(`/etraining_presential/presential/${this.id_course}/save_subscription/`, data, this.getHeader)
            .then(response => {

                if (!this.user_subscribed) {
                    this.user_subscribed = true

                    this.$q.notify({
                        message: this.$t('subscribed_for_presential_training_successfully'),
                        type: 'positive',
                        icon: 'fal fa-sign-in'
                    })
                }
                else {
                    this.user_subscribed = false

                    this.$q.notify({
                        message: this.$t('unsubscribed_for_presential_training_successfully'),
                        type: 'positive',
                        icon: 'fal fa-sign-out'
                    })
                }
            })
            .catch((e) => {
                if (e.response.data.orientation === 'no_vacancy') {
                    this.$q.notify({
                        message: this.$t('no_vacancy'),
                        type: 'negative',
                        icon: 'fal fa-users-slash'
                    })
                    this.fetchCourse()

                    return
                } else console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
                this.confirm_subscribe_presential = false
            })
        },

        getPercentage(percentage) {
            if (!percentage) {
                return 0
            }
            else if (percentage <= 100) {
                return parseInt(percentage)
            }
        },

        getDonutColor(percentage) {
            if (percentage > 0 && percentage <= 24) {
                return '#DB2828'
            }
            else if (percentage >= 25 && percentage <= 74) {
                return '#F2C037'
            }
            else if(percentage >= 75) {
                return '#21BA45'
            }
        },

        reloadActivity() {
            this.$axios.get(`/etraining_presential/presential/${this.id_course}/get_presential_event_user_progress/`, this.getHeader)
            .then(response => {
                this.user_progress = response.data.user_progress ? parseInt(response.data.user_progress) : 0
                this.presential_event_user_result_status = response.data.presential_event_user_result_status
                this.presential_event_user_result_score = response.data.presential_event_user_result_score
                this.presential_event_user_result_date = date.formatDate(response.data.presential_event_user_result_date, 'DD/MM/YYYY')

                this.sections = []

                if (this.presential_event_user_result_status != 2) {
                    this.sections.push({
                        value: this.user_progress ? this.user_progress > 100 ? 100 : this.user_progress : 0,
                        color: this.getDonutColor(this.user_progress)
                    })
                }
                else {
                    this.sections.push({
                        value: 100,
                        color: '#DB2828'
                    })
                }
            })
            .catch(e => {
                console.log(e)
            })
        },

        showCertificate() {
            if(this.course.status === 5 && !this.presential_event_user_result_status == 1) {
                this.$q.notify({
                    message: this.$t('training_not_finished_please_wait'),
                    type: 'warning',
                    icon: 'fal fa-user-clock'
                })
                return
            }
            else if (this.presential_event_user_result_status == 1) {
                this.$q.loading.show()

                this.$axios.get(`/etraining_presential/presential/${this.$route.params.id}/get_presential_event_user_result_certificate/`, this.getHeader)
                .then(response => {
                    this.certificate = { group_training_title: this.title }
                    this.certificate_data = response.data
                    this.show_certificate = true
                    this.$q.loading.hide()
                })
                .catch(e => {
                    this.$q.loading.hide()
                    console.log(e)
                })
            }
        },

        hideCertificate() {
            this.show_certificate = false
            this.certificate_data = []
        },

        hideCourseInfo() {
            this.confirm_subscribe_presential = false
        },

        getHumanTimezone(location) {
            const gmt = moment.tz(location).format('z')
            if (gmt === 'GMT') {
                return `${gmt} 0`
            } else return `GMT ${gmt}`
        }
    },

    created() {
        this.id_course = this.$route.params.id
        this.fetchCourse()
    },
}
</script>

<style>

</style>
